import { Component, Input, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { DestroyableDirective } from "../../abstract/destroyable";
import { ExternalVideo } from "../../models/external-video";
import * as FaqActions from "./faqs-show.actions";
import * as HelpSelectors from "@app/shared/state/help/help.selectors";
import { KeheFaq } from "@kehe/phoenix-faqs";

@Component({
  selector: "app-faqs-show",
  templateUrl: "./faqs-show.component.html",
  styleUrls: ["./faqs-show.component.scss"],
  standalone: false,
})
export class FaqsShowComponent extends DestroyableDirective implements OnInit {
  @Input() faqOverride: KeheFaq[];
  @Input() showTitle = true;
  public faqs: KeheFaq[] = [];
  public filteredFaqs: KeheFaq[];

  constructor(private _store: Store) {
    super();
  }

  ngOnInit() {
    this._store.dispatch(FaqActions.componentLoaded());
    if (!this.faqOverride) {
      this._store
        .pipe(select(HelpSelectors.selectShowFaqs), takeUntil(this.destroy$))
        .subscribe((val) => {
          this.faqs = val;
          this.filteredFaqs = val;
        });
    } else {
      this.faqs = this.faqOverride;
      this.filteredFaqs = this.faqOverride;
    }
  }

  searchChanged($event: string): void {
    if ($event) {
      const searchTerms = $event.toLocaleLowerCase().split(" ");
      this.filteredFaqs = this.faqs.filter((f) =>
        searchTerms.some((s) => f.question.toLocaleLowerCase().includes(s)),
      );
    } else {
      this.filteredFaqs = [...this.faqs];
    }
  }

  playVideo(faq: KeheFaq): void {
    this._store.dispatch(
      FaqActions.videoSelected({
        video: new ExternalVideo(
          "Faq #" + faq.sequence,
          faq.videoId,
          faq.group,
        ),
      }),
    );
  }
}
